import React from 'react'
import { HTMLSelect } from '../../../components/ui/html-select'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'

const defaultOptions = [5, 10, 15, 50, 100, 200, 300]

interface PerPageSelectProps {
    options?: number[]
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    value: number
    className?: string
    minimal?: boolean
    label?: string
    small?: boolean
}

export const PerPageSelect = ({
    options = defaultOptions,
    onChange,
    value,
    className,
    minimal = false,
    label = 'per page',
    small,
}: PerPageSelectProps) => {
    return (
        <div className={classNames(className, 'w-max-1 inline-flex items-center')}>
            <HTMLSelect
                className={classNames('p-0 html-select-small mr-1', { 'text-xs': small })}
                minimal={minimal}
                id="per-page-select"
                onChange={onChange}
                value={value}
            >
                {options.map((el) => (
                    <option key={el} value={el}>
                        {el}
                    </option>
                ))}
            </HTMLSelect>

            {label && <span className={classNames({ 'text-xs': small })}>{label}</span>}
        </div>
    )
}
